export default __webpack_public_path__ + "static/media/Machine Metrics.16c607ff.png";